import { combineReducers } from "redux";
import { routerReducer } from 'react-router-redux';
import initializer from "./initializer";
import proxyManager from "./proxyManager";
import formManager from "./formManager";
import userManager from "./userManager";
import teamManager from "./teamManager";
import environmentManager from "./environmentManager";
import { authReducer } from "./auth";
import authorizationManager from "./authorizationManager";
import productForm from "./productForm";
import applicationTypesList from "./applicationTypesList";

// Combining all reducers to single root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  routing: routerReducer,
  common: initializer,
  proxyManager: proxyManager,
  formManager: formManager,
  userManager: userManager,
  environmentManager: environmentManager,
  teamManager: teamManager,
  authorizationManager: authorizationManager,
  productForm: productForm,
  applicationTypesList: applicationTypesList
});

export default rootReducer;